import React, { useState, useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";

import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

import styles from "./index.module.css";

interface AnswerFillBlankProps {
  value?: string;
  correctAnswer?: string;
  onSubmit: (answer: string) => void;
}

const AnswerFillBlank: React.FC<AnswerFillBlankProps> = ({ value, correctAnswer, onSubmit }) => {
  const { t } = useTranslation();
  
  const [text, setText] = useState<string>(value || '');
  const [hasSubmitted, setHasSubmitted] = useState<boolean>(!!value);

  useEffect(() => {
    if (value) {
      setText(value);
      setHasSubmitted(true);
    }
  }, [value]);

  const isCorrect = hasSubmitted && text.toLowerCase().trim() === correctAnswer?.toLowerCase().trim();
  const isIncorrect = hasSubmitted && !isCorrect;

  const handleSubmit = useCallback(() => {
    if (text.trim().length < 1) return;
    
    setHasSubmitted(true);
    onSubmit(text.trim());
  }, [text, onSubmit]);

  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    if (!hasSubmitted) {
      setText(event.target.value);
    }
  }, [hasSubmitted]);

  return (
    <div className={styles.container}>
      <TextField
        fullWidth
        variant="outlined"
        value={text}
        onChange={handleChange}
        disabled={hasSubmitted}
        placeholder={t('questionCards.fill_in_the_blank.placeholder')}
        className={`${styles.textField} ${isCorrect ? styles.correct : ''} ${isIncorrect ? styles.incorrect : ''}`}
      />

      {!hasSubmitted && text.trim().length > 0 && (
        <div className="w-full">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            className={styles.submitButton}
            fullWidth
          >
            {t('actions.submit')}
          </Button>
        </div>
      )}

    </div>
  );
};

export default AnswerFillBlank;
